import { Skeleton, Stack } from '@mui/material';
import { useComponentResponsiveProps } from '../../../hooks/useComponentResponsiveProps';
import { ChartLegend } from './ChartLegend';

type ResponsiveContentType = {
  chartRadius: number;
  stackDirection: 'column' | 'row-reverse';
  alignItems: 'center' | 'flex-start';
};

export const ChartContent = () => {
  const [responsiveContainerRef, responsiveData] = useComponentResponsiveProps<ResponsiveContentType, HTMLDivElement>({
    xs: {
      chartRadius: 90,
      stackDirection: 'column',
      alignItems: 'center',
    },
    sm: {
      chartRadius: 120,
      stackDirection: 'row-reverse',
      alignItems: 'flex-start',
    },
  });

  const diameter = 2 * responsiveData.chartRadius;
  return (
    <Stack
      data-role="chart-content-skeleton"
      ref={responsiveContainerRef}
      direction={responsiveData.stackDirection}
      spacing={2}
      sx={{
        '& > *': {
          flex: 1,
        },
        alignItems: responsiveData.alignItems,
      }}
    >
      <Stack justifyContent={'center'} alignItems={'center'} sx={{ p: 0.625 }}>
        <Skeleton variant="circular" width={diameter} height={diameter} />
      </Stack>
      <ChartLegend amount={3} />
    </Stack>
  );
};
